module.exports = __webpack_public_path__ + "static/img/logo.77da437e.png";